/**
 * Disconnect confirmation — prototype/integrations-frames.js frame 14
 * (`set(13,...)`). Disconnect is a hard delete (cake-app/src/Controller/Api/
 * IntegrationsController.php DELETE — no soft-delete flag): the data it
 * brought in is actually removed from widgets, not just frozen in place.
 * Reconnecting the same account later is possible and restores what the
 * widget shows, but it re-syncs from scratch — the specific sync history
 * itself isn't recovered. Copy says "data", not "events" — future
 * integrations won't all be calendars.
 */
import React from "react";
import ConfirmDialog from "../../theme/untitled/ConfirmDialog/ConfirmDialog";
import Icon from "../../theme/untitled/icons/Icon";
import { INTEGRATION_NAMES, INTEGRATION_SHORT_NAMES } from "../../../../consts";

const DisconnectDialog = ({ integration, busy, onClose, onConfirm }) => (
  <ConfirmDialog
    open={Boolean(integration)}
    onClose={onClose}
    onConfirm={onConfirm}
    variant="destructive"
    icon={<Icon name="Trash01" size={24} />}
    title={integration ? `Disconnect this ${INTEGRATION_SHORT_NAMES[integration.type]} account?` : ""}
    confirmLabel="Disconnect"
    busy={busy}
  >
    <p>
      Syncing stops immediately for <b>{integration?.username}</b>, and the data it
      brought in is removed from your widgets.
    </p>
    <p>
      Nothing changes in {integration ? INTEGRATION_NAMES[integration.type] : ""} itself. You can
      connect the account again, but it will sync from scratch.
    </p>
  </ConfirmDialog>
);

export default DisconnectDialog;
